export default {
  roadmap_title_first:
    'We always strive to optimize product capabilities and Provide Better Services',
  roadmap_title_second: 'RoadMap',
  roadmap_version: 'Learn more about InGame Update History',
};
